import { useEffect, useState } from 'react';
import { classLabel } from '@/lib/dropKinds.js';
import { getDropContext } from '@/services/deals.service.js';

// "WRONG TYPE? CHANGE IT" (paperwork-1 R4; N5, David 2026-11-01: "any filed document can be re-typed to any type, application
// included (through the application writer, asking the signing date)"). One control for the Paperwork tab's filed rows and the
// drop's filed row. A kind posts at once; Signed application first asks the day it was signed (required, never defaulted, its
// latest the server's: the drop context's signed_on_latest, today Eastern) and a button that names what it does. Every answer
// (the new name, a refusal, a partial filing) is the server's and is said by the caller on the row and in a toast.

const sel = 'min-h-[28px] min-w-0 max-w-full rounded-card border border-border bg-bg px-1.5 text-[12px] text-text';
const btn = 'rounded-md border border-border-strong px-2.5 py-2 text-[11px] text-text hover:bg-surface-strong disabled:opacity-50 sm:py-1';
const btnPrimary = 'rounded-md border border-accent bg-accent px-2.5 py-2 text-[11px] text-white hover:brightness-110 disabled:opacity-50 sm:py-1';

export default function RetypeControl({ doc, dealId, kinds, disabled = false, onRetype, latest: givenLatest = null, className = '', selectAttr = 'data-filed-retype' }) {
  const [asking, setAsking] = useState(false);
  const [day, setDay] = useState('');
  const [latest, setLatest] = useState(givenLatest);
  const [latestRead, setLatestRead] = useState(!!givenLatest);
  useEffect(() => {
    if (!asking || latestRead || !dealId) return;
    getDropContext(dealId).then((r) => setLatest(r?.signed_on_latest || null)).catch(() => setLatest(null)).finally(() => setLatestRead(true));
  }, [asking, latestRead, dealId]);
  // Filed (the row's kind is now the answer): the question is over (Chrome pass 2026-11-01: it stood on the re-typed row, its
  // button offering to file the application as the application again).
  useEffect(() => { setAsking(false); setDay(''); }, [doc.class]);
  const pick = (kind) => {
    if (!kind || kind === doc.class) return;
    if (kind === 'application') { setAsking(true); return; }
    onRetype(kind);
  };
  const late = !!(day && latest && day > latest);
  return (
    <div className={`flex flex-col gap-1.5 text-text-muted ${className}`} data-retype-control={doc.id}>
      <label className="flex flex-wrap items-center gap-1">
        Wrong type? Change it
        <select className={sel} value={asking ? 'application' : doc.class} disabled={disabled}
          onChange={(ev) => pick(ev.target.value)} {...{ [selectAttr]: doc.id }} aria-label={`Change the type of ${doc.name}`}>
          {kinds.some((k) => k.kind === doc.class) ? null : <option value={doc.class}>{classLabel(doc.class)}</option>}
          {kinds.map((k) => <option key={k.kind} value={k.kind}>{k.label}</option>)}
        </select>
      </label>
      {asking ? (
        <div className="flex flex-wrap items-center gap-2" data-retype-signed-on={doc.id}>
          <label className="flex flex-wrap items-center gap-2 text-[12px]">
            <span>Signed on (the date on the application)</span>
            <input type="date" required max={latest || undefined} value={day} onChange={(ev) => setDay(ev.target.value)} disabled={disabled}
              className="min-h-[28px] rounded-card border border-border bg-bg px-2 text-[12px] text-text" aria-label={`The day ${doc.name} was signed`} />
          </label>
          {late ? <span className="text-warning">That day is after today; say the day on the application.</span> : null}
          <button type="button" className={btnPrimary} disabled={disabled || !day || late} onClick={() => onRetype('application', { signed_on: day })} data-action="retype_to_application">
            {day ? `File ${doc.name} as the signed application, signed ${day}` : 'Say the day it was signed first'}
          </button>
          <button type="button" className={btn} disabled={disabled} onClick={() => { setAsking(false); setDay(''); }}>Keep it as {classLabel(doc.class)}</button>
        </div>
      ) : null}
    </div>
  );
}
